<div class="container">

  <!-- PAGE HEADER -->
  <div class="row mt-4">
    <div class="col-12">
      <h3 class="side-panel-label mb-2">Employee Management</h3>
    </div>
  </div>

  <!-- CUSTOM TABS -->
  <div class="tab-container mt-2">
    <div
      class="tab-item"
      [class.active]="activeTab === 'import'"
      (click)="activeTab = 'import'">
      Import Employees
    </div>

    <div
      class="tab-item"
      [class.active]="activeTab === 'assign'"
      (click)="activeTab = 'assign'">
      Assign Admins
    </div>
  </div>

  <!-- IMPORT WRAPPER -->
  <div class="mt-4">
    <app-import-wrapper
      *ngIf="activeTab === 'import'"
      [validator]="importValidator"
      (importCompleted)="onImportCompleted($event)">
    </app-import-wrapper>
  </div>

  <!-- ADMIN ASSIGNMENT -->
  <div class="mt-4">
    <app-admin-assignment
      *ngIf="activeTab === 'assign'"
      (saveAssignmentAction)="onAssignmentSaved($event)"
      [history]="adminAssignmentHistory"
      (goImport)="goToImport()">
    </app-admin-assignment>
  </div>

</div>
